import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import RequestStateChip from '../RequestStateChip/RequestStateChip';
import { RootState } from '../../../../shared/redux/store';
import { formatDate } from '../../../../shared/utils/formatDate';

const RequestPreview = () => {
  const request = useSelector((state: RootState) => state.requestSearch.searchRequest.equivalencies);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: '0px', sm: '10px' },
        marginBottom: '25px',
        alignItems: { xs: 'flex-start', sm: 'center' }
      }}
    >
      <RequestStateChip state={request?.state} />
      <Box className="EQXXI-RequestDetail-CaseNumber-Container" sx={{ alignSelf: { xs: 'flex-start', sm: 'center' } }}>
        <Typography className="EQXXI-RequestDetail-CaseNumber-Label" variant="h6" sx={{ padding: { xs: '0px' } }}>{t('tramitNumber') as string}: </Typography>
        <Typography
          data-testid="case-number"
          className="EQXXI-RequestDetail-CaseNumber"
          variant="h6"
          sx={{ padding: { xs: '0px' } }}
        >
          {request?.case_number}
        </Typography>
      </Box>
      {request?.created_date ? <Box className="EQXXI-RequestDetail-CaseNumber-Container" sx={{ alignSelf: { xs: 'flex-start', sm: 'center' } }}>
        <Typography className="EQXXI-RequestDetail-CaseNumber-Label" variant="h6" sx={{ padding: { xs: '0px' } }}>{t('createdDate') as string}: </Typography>
        <Typography
          className="EQXXI-RequestDetail-CaseNumber"
          variant="h6"
          sx={{ padding: { xs: '0px' } }}
        >
          {formatDate(request.created_date)}
        </Typography>
      </Box> : null}
    </Box>
  );
};

export default RequestPreview;
